import dayjs, { Dayjs } from "utils/dayjs"

import { ApiLinkEntity, ApiLinkRel, AsyncReportState } from "config/constants"
import { Guid, IApiLink } from "@/types"

export const STOCKTAKING_SCOPE_REPORT_ASSETS_LIMIT = 2000

export enum StocktakingScopeStatus {
    scanningNotStarted = "scanningNotStarted",
    scanningInProgress = "scanningInProgress",
    scanningCompleted = "scanningCompleted",
    warehouseClosed = "warehouseClosed",
}

export interface IStocktakingScopeReport {
    uri?: string
    state: AsyncReportState
}

export interface IGetStocktakingScopeDto {
    warehouseId: Guid
    scopeStatus: StocktakingScopeStatus
    scanningStartedByUserId?: Guid | null
    scanningStartDate?: string | null
    completedByUserId?: Guid | null
    completedDate?: string | null
    closedByUserId?: string | null
    closedDate?: string | null
    report?: {
        uri?: string | null
        state: AsyncReportState
    } | null
    links?: IApiLink[]
}

interface IStocktakingScopeAdditionalParams {
    warehouseDescription: string,
    isNoWarehouse: boolean
    emails: { [userId: string]: string }
}

export default class StocktakingScope {
    warehouseId: Guid
    warehouseDescription?: string
    isNoWarehouse?: boolean
    scopeStatus: StocktakingScopeStatus
    scanningStartedBy?: string
    scanningStartDate?: Dayjs
    completedBy?: string
    completedDate?: Dayjs
    closedBy?: string
    closedDate?: Dayjs
    report?: IStocktakingScopeReport
    linkReopen?: IApiLink
    linkClose?: IApiLink
    linkComplete?: IApiLink
    linkRecordAsset?: IApiLink
    linkGetNotScannedAssets?: IApiLink

    constructor(
        dto: IGetStocktakingScopeDto,
        params: IStocktakingScopeAdditionalParams
    ) {
        this.warehouseId = dto.warehouseId
        this.warehouseDescription = params.warehouseDescription
        this.isNoWarehouse = params.isNoWarehouse
        this.scopeStatus = dto.scopeStatus
        this.scanningStartedBy = dto.scanningStartedByUserId ? params.emails[dto.scanningStartedByUserId] : undefined
        this.scanningStartDate = dto.scanningStartDate ? dayjs(dto.scanningStartDate) : undefined
        this.completedBy = dto.completedByUserId ? params.emails[dto.completedByUserId] : undefined
        this.completedDate = dto.completedDate ? dayjs(dto.completedDate) : undefined
        this.closedBy = dto.closedByUserId ? params.emails[dto.closedByUserId] : undefined
        this.closedDate = dto.closedDate ? dayjs(dto.closedDate) : undefined
        this.report = dto.report ? {
            uri: dto.report.uri || undefined,
            state: dto.report.state,
        } : undefined
        this.linkReopen = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.stocktakingScopeReopen && lnk.rel === ApiLinkRel.update)
        this.linkClose = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.stocktakingScopeClose && lnk.rel === ApiLinkRel.update)
        this.linkComplete = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.stocktakingScopeComplete && lnk.rel === ApiLinkRel.update)
        this.linkRecordAsset = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.stocktakingItem && lnk.rel === ApiLinkRel.new)
        this.linkGetNotScannedAssets = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.stocktakingNotScannedAssets && lnk.rel === ApiLinkRel.all)
    }

    get hasReportButton(): boolean {
        return !!this.report
    }
}
